module.exports = __webpack_public_path__ + "assets/images/img/invite_players/settings_android_allow.36f75b8ca0f41f6209f8eb4fdbde339c.png";